import CpHowItWorks from "@/components/communityPortal/home/CpHowItWorks";
import NotFound from "@/components/common/NotFound";
import { isCommunityPortal } from "@/utils/type";

const CpHowItWorksPage = ({ type }) => {
    return isCommunityPortal(type) ? <CpHowItWorks /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default CpHowItWorksPage;
